import React from "react";
import { Trans, useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import TriangularTriangle from "../../../static/images/Triangular-Triangle.webp";
import { BookMeeting } from "../../components/BookMeeting";
import { Container } from "../../components/Container";

const banner = css`
  ${tw`flex items-center justify-center mx-auto text-center`}
  h1 {
    ${tw`text-4xl sm:text-5xl leading-none font-black mt-8`}
  }
  img {
    ${tw`fill-current mx-auto w-[50%] h-3/4 my-20`}
  }
`;

const Banner: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();

  return (
    <Container {...rest}>
      <article id="banner" css={banner}>
        <div tw="text-center">
          <h1 tw="mt-8">{t("hero.header")}</h1>
          <img src={TriangularTriangle} alt={t("index.introduction.triangularTriangleAlt")} />
          <p tw="text-xl sm:text-2xl md:text-4xl mt-2 mb-2">
            <Trans i18nKey="hero.subheader" components={{ bold: <strong /> }} />
          </p>
          <BookMeeting commentFirst={true} />
          <br />
        </div>
      </article>
    </Container>
  );
};

export default Banner;
